import React, { useState, useEffect } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { Button, Col, Container, Form, Row, DropdownButton, Dropdown, InputGroup, Card, ListGroup,Alert } from "react-bootstrap";
import { getActiveChains, submitApplicationForm } from "../../Action/action";
import { checkContractOnChain } from "../../Web3/web3FunctionCall";
import toast, { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import ReactApexChart from 'react-apexcharts';
import { Link, useNavigate } from "react-router-dom";
import { useDisconnect, useAccount } from "wagmi";
import Web3WalletProvider from '../../ConnectWallet/walletProvider'
import { TokenSupply } from "../../Web3/Connector";
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import { showLoader, hideLoader } from "../loader";
import { ApproveToken, NewSale, UsdtDecimals } from "../../Web3/Connector";
import { MdOutlineDateRange } from "react-icons/md";
import config from "../../config";
import "../Forms/css/form.css"


export default function Promote() {
  const [form, setForm] = useState({
    tokenName: "",
    tokenAddress: "",
    tokenSymbol: "",
    chainNetwork: "",
    description: "",
    startDateAndTime: "",
    duration: "",
    logo: null,
    kyc: "",
    audit: "",
    website: "",
    telegram: "",
    youtube: "",
    linkedin: "",
    //   liquidityValue:"",
    privateSaleValue: "",
    icoValue: "",
    team: "",
    partnerships: "",
    others: "",
    hardCap: "",
    softCap: "",
    // tokenAmount: "",
    usdtPrice: "",
    //nativePrice: "",
    whitepaper: "",
    socialAccounts: [{ name: "", link: "" }],
    agree: false,
  });

  const [errors, setErrors] = useState({});
  const [chainOptions, setChainOptions] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [getRpc, setRpc] = useState();
  const dispatch = useDispatch();
  const [update, setUpdate] = useState(false);
  //const loginDetails = useSelector((state) => state.auth.LoginDetails);
  const percentage = [60, 65, 75, 80, 85, 90, 95, 100]
  const [percent, setPercent] = useState(60)
  const [supply, setSupply] = useState(0)
  const [symbol, setSymbol] = useState("")
  const [presaleAmount, setPresaleAmount] = useState(0)
  const [tokenPrice, setTokenPrice] = useState(0)
  const [chainId, setChainId] = useState('')
  const [presaleAddr, setPresaleAddr] = useState('')
  const [usdtAddr, setUsdtAddr] = useState('')
  let _useWeb3WalletProvider = Web3WalletProvider()
  const { address, isConnected } = useAccount()
  const [connectWalletNow, setconnectWalletNow] = useState(false);
  const [presaleLoading, setPresaleLoading] = useState(false)



  const [chart, setChart] = useState({
    series: [0, 0, 0, 0, 0],
    options: {
      chart: {
        type: 'donut',
      },
      labels: ['Private Sale', 'PreSale/ICO', 'Team', 'Partnerships', 'Others'],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      }]
    }
  })

  const [fields, setFields] = useState([{ name: "" }]);
  // /------
  //  charts
  // -----------
  // Function to handle adding new fields
  const handleAddField = () => {
    setFields([...fields, { name: "" }]);
  };

  // Function to handle removing fields
  const handleRemoveField = (index) => {
    const newFields = fields.filter((_, i) => i !== index);
    setFields(newFields);
  };

  // Function to handle input change
  const handleChange = (index, event) => {
    const newFields = [...fields];
    newFields[index].name = event.target.value;
    setFields(newFields);
  };

  // Function to handle form submission
  const handleSubmit2 = (event) => {
    event.preventDefault();
    console.log("Submitted Fields:", fields);
  };

  // ----------
  //console.log("LOGIN",loginDetails)
  const navigate = useNavigate();

  useEffect(() => {
    getChains();
  }, []);

  useEffect(() => {
    if (form.hardCap && percent) {
      let softcap = (form.hardCap * percent) / 100;
      setForm((prevForm) => ({
        ...prevForm,
        softCap: softcap
      }))
    }
  }, [form.hardCap, percent])

  const handlePercentChange = (e) => {
    let value = parseInt(e.target.value)
    setPercent(value)
  }

  const now = new Date();
  const minSelectableTime = new Date();
  minSelectableTime.setMinutes(minSelectableTime.getMinutes() + 15);


  const getChains = async () => {
    try {
      const response = await getActiveChains();
      console.log('chains', response)
      if (response.success) {
        setChainOptions(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleInputChange = async (e) => {
    const { name, value } = e.target;
    if (name === "chainNetwork") {
      for (let i = 0; i < chainOptions.length; i++) {
        if (chainOptions[i].id == value) {
          setRpc(chainOptions[i].chainRPCUrl);
          setChainId(chainOptions[i].chainNetworkId)
          setPresaleAddr(chainOptions[i].presaleContract)
          setUsdtAddr(chainOptions[i].usdtContract)
        }
      }
      setErrors((prevErrors) => ({
        ...prevErrors,
        chainNetwork: ""
      }))
    }
    if (name === 'duration' && value === 0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        duration: 'Sale duration cannot be 0',
      }));
    }
    if (name === "tokenAddress") {
      if (!form.chainNetwork) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          chainNetwork: "Please select a chain network before entering the token address."
        }))
        return
      }

      const totalTokenSupply = async () => {
        let request = {
          walletProvider: _useWeb3WalletProvider,
          tokenAddress: value,
          networkId: chainId
        }
        let res = await TokenSupply(request)
        console.log('SSSSS', request)
        let supplyValue = (Number(res.supply) / 10 ** 18)
        let symb = res.symbol
        setSupply(supplyValue)
        setSymbol(symb)

      }
      await totalTokenSupply()
    }

    setForm({
      ...form,
      [name]: value,
    });
    if (['privateSaleValue', 'icoValue', 'team', 'partnerships', 'others'].includes(name)) {
      updateChart({ ...form, [name]: value })
    }

    if (name === "icoValue") {
      let res = (value * supply) / 100
      setPresaleAmount(res)
      let price = form.hardCap / res
      console.log('p1', price)
      if (chainId === '0x61') {
        price = Math.floor(price * 1e18) / 1e18;
      } else {
        price = Math.floor(price * 1e6) / 1e6;
        console.log('p2', price)
      }
      setTokenPrice(price)
    }
  };

  useEffect(() => {
    setForm((prevForm) => ({
      ...prevForm,
      liquidityValue: supply,
      tokenAmount: presaleAmount
    }));
  }, [supply, presaleAmount])

  const updateChart = (updateForm) => {
    const { privateSaleValue, icoValue, team, partnerships, others } = updateForm

    const allocated = {
      privateSale: (parseFloat(privateSaleValue) || 0),
      ico: (parseFloat(icoValue)),
      team: (parseFloat(team) || 0),
      partnerships: (parseFloat(partnerships) || 0),
      others: (parseFloat(others) || 0)
    }

    const totalAllocated = Object.values(allocated).reduce((sum, val) => sum + val, 0);

    if (totalAllocated > 100) {
      toast.error('Total percentage cannot exceed 100%')
      return;
    }
    const unallocatedPercentage = 100 - totalAllocated;

    setChart((prevData) => ({
      ...prevData,
      series: [
        (allocated.privateSale * supply) / 100,
        (allocated.ico * supply) / 100,
        (allocated.team * supply) / 100,
        (allocated.partnerships * supply) / 100,
        (allocated.others * supply) / 100,
        (unallocatedPercentage * supply) / 100,
      ],
      options: {
        ...prevData.options,
        labels: [
          "Private Sale",
          "PreSale/ICO",
          "Team",
          "Partnerships",
          "Others",
          "Unallocated", // Label for the grey area
        ],
        colors: [
          "#008FFB", // Private Sale
          "#00E396", // ICO
          "#FEB019", // Team
          "#FF4560", // Partnerships
          "#775DD0", // Others
          "#E0E0E0", // Grey for unallocated
        ],
      }
    }))
  }

  const chartStyle = {
    maxWidth: '400px',
    margin: '0 auto',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    const validImageTypes = [
      'image/jpeg',
      'image/png',
      'image/gif',
      'image/bmp',
      'image/webp',
      'image/svg+xml'
    ];

    if (file && validImageTypes.includes(file.type)) {

      setForm({
        ...form,
        logo: file,

      });
      setImagePreview(URL.createObjectURL(file));
    } else {
      alert('Please select a valid image file (jpeg, png, gif, bmp, webp, svg)');
    }
  }

  const handleSocialAccountChange = (index, e) => {
    const { name, value } = e.target;
    const socialAccounts = [...form.socialAccounts];
    socialAccounts[index][name] = value;
    setForm({
      ...form,
      socialAccounts,
    });
  };

  const addSocialAccount = () => {
    setForm({
      ...form,
      socialAccounts: [...form.socialAccounts, { name: "", link: "" }],
    });
  };



  const handleCheckboxChange = (e) => {
    setForm({
      ...form,
      agree: e.target.checked,
    });
  };


  const validateForm = async () => {
    const newErrors = {};
    const urlPattern =
      /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/i;

    const isInvalidNumber = (value) => isNaN(value) || value === '' || value < 0;
    const requiredFields = [
      "tokenName",
      "tokenAddress",
      "description",
      "logo",
      "liquidityValue",
      "privateSaleValue",
      "icoValue",
      "team",
      "partnerships",
      "others",
      "hardCap",
      "whitepaper",
      "tokenAmount",
    ];

    requiredFields.forEach((field) => {
      if (["liquidityValue", "privateSaleValue", "team", "partnerships", "others", "hardCap", "tokenAmount"].includes(
        field
      ) &&
        isInvalidNumber(form[field])
      ) {
        newErrors[field] = `${field} must be a valid positive number`;
      }
    });

    if (isInvalidNumber(form.icoValue) || parseFloat(form.icoValue) === 0) {
      newErrors.icoValue = "ICO value must be a valid positive number and cannot be zero";
    }

    if (!form.duration) {
      newErrors.duration = "Duration is required";
    } else if (isInvalidNumber(form.duration)) {
      newErrors.duration = "Duration must be a valid positive number";
    }

    if (!form.website) {
      newErrors.website = "Website is required";
    }

    if (!form.startDateAndTime) {
      newErrors.startDateAndTime = "Select a start date and time";
    }


    if (!form.agree) {
      newErrors.agree = "You must agree to the terms";
    }
    const socialLinks = ["website", "telegram", "youtube", "linkedin"];
    socialLinks.forEach((field) => {
      if (form[field] && !urlPattern.test(form[field])) {
        newErrors[field] = `Invalid URL format for ${field}`;
      }
    });
    let result = await checkContractOnChain(getRpc, form.tokenAddress);
    if (!result.status) {
      newErrors.tokenAddress = `${result.msg}`;
    }

    console.log(newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isConnected) {
      toast.error("Please connect your wallet.");
      setconnectWalletNow(true)
      return
    }

    if (await validateForm()) {
      form.owner_address = address
      form.socialAccount = JSON.stringify(form.socialAccounts);
      form.tokenSymbol = symbol
      form.usdtPrice = tokenPrice
      //console.log("Form submitted", form);
      try {
        showLoader()
        setPresaleLoading(true)
        let request = {
          walletProvider: _useWeb3WalletProvider,
          tokenOwner: address,
          tokenAddress: form.tokenAddress,
          tokenAmount: form.tokenAmount,
          UsdtPrice: tokenPrice,
          preSaleAddress: presaleAddr,
          usdtAddress: usdtAddr,
          duration: form.duration,
          startDateAndTime: form.startDateAndTime,
          networkId: chainId
        }
        let approval = await ApproveToken(request)
        console.log('APPP', request)
        if (approval.status) {
          let res = await NewSale(request)
          console.log('FORMRES', res)
          if (res.status) {
            toast.success(res.message)
            let result = await submitApplicationForm(form)
            navigate(`${config.baseUrl}launchpad`, { replace: true })
            window.scrollTo(0, 0)
          } else {
            toast.error(res.message)
            setPresaleLoading(false)
          }
        } else {
          toast.error(approval.message)
          setPresaleLoading(false)
        }
      } catch (error) {
        console.log('Error Presale', error)
        alert('Presale Error', error)
      } finally {
        hideLoader()
        setPresaleLoading(false)
      }
    } else {
      toast.error("Please check the validations required.");
    }
  }




  return (
    <>
      <Toaster />
      <Header />
      <section className="process_form">
        <Container>
          <Form >
            <div className="from_box my-5">
              <h2>The Launch process:</h2>
              <p>
                Must be confirmed with the Owner wallet (the tokens will be
                transferred to the INFI CDEX Launchpool)
              </p>

              <p
                style={{
                  textAlign: "right",
                  fontSize: "12px",
                  fontStyle: "italic",
                  marginTop: "-10px"
                }}
              >Fields marked with * are compulsory</p>

              <Row className="">
                <Col lg={6} className="mb-4">
                  <Form.Label>Token Name *</Form.Label>
                  <Form.Control
                    type="text"
                    name="tokenName"
                    value={form.tokenName}
                    onChange={handleInputChange}
                    isInvalid={!!errors.tokenName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.tokenName}
                  </Form.Control.Feedback>
                </Col>

                <Col lg={6} className="mb-4">
                  <Form.Label>Chain Network *</Form.Label>
                  <Form.Control
                    as="select"
                    name="chainNetwork"
                    value={form.chainNetwork}
                    onChange={handleInputChange}
                    isInvalid={!!errors.chainNetwork}
                  >
                    <option value="">Select Network</option>
                    {chainOptions.map((option, index) => (
                      <option key={index} value={option.id}>
                        {option.chainName}
                      </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.chainNetwork}
                  </Form.Control.Feedback>
                </Col>

                <Col lg={6} className="mb-4">
                  <Form.Label>Token Address *</Form.Label>
                  <Form.Control
                    type="text"
                    name="tokenAddress"
                    value={form.tokenAddress}
                    onChange={handleInputChange}
                    isInvalid={!!errors.tokenAddress}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.tokenAddress}
                  </Form.Control.Feedback>
                </Col>

                <Col lg={6} className="mb-4">
                  <Form.Label>Token Symbol *</Form.Label>
                  <Form.Control
                    type="text"
                    name="tokenSymbol"
                    value={symbol}
                    onChange={handleInputChange}
                    isInvalid={!!errors.tokenSymbol}
                    disabled={!update ? true : false}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.tokenSymbol}
                  </Form.Control.Feedback>
                </Col>

                <Col lg={12} className="mb-4">
                  <Form.Label>Description *</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="description"
                    placeholder="max 1500 characters"
                    value={form.description}
                    onChange={handleInputChange}
                    isInvalid={!!errors.description}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.description}
                  </Form.Control.Feedback>
                </Col>

                <Col lg={12} className="mb-4">
                  <Form.Label>ADD a Brand Logo/Upload a Logo *</Form.Label>
                  <div className="position-relative">
                    <Form.Control
                      type="file"
                      className="custom_dragdrop_form"
                      onChange={handleFileChange}
                      isInvalid={!!errors.logo}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.logo}
                    </Form.Control.Feedback>
                    <div className="custom_dragdrop my-3">
                      <span>
                        Click to upload files, or drag & drop files here
                      </span>
                    </div>
                    {imagePreview && (
                      <div className="image-preview mt-3">
                        <img
                          src={imagePreview}
                          alt="Preview"
                          style={{ maxHeight: "200px", maxWidth: "100%" }}
                        />
                      </div>
                    )}
                  </div>
                </Col>

                <Col lg={6} className="mb-4">
                  <Form.Label>ADD KYC</Form.Label>
                  <Form.Control
                    type="text"
                    name="kyc"
                    value={form.kyc}
                    onChange={handleInputChange}
                    isInvalid={!!errors.kyc}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.kyc}
                  </Form.Control.Feedback>
                </Col>

                <Col lg={6} className="mb-4">
                  <Form.Label>ADD Audit</Form.Label>
                  <Form.Control
                    type="text"
                    name="audit"
                    value={form.audit}
                    onChange={handleInputChange}
                    isInvalid={!!errors.audit}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.audit}
                  </Form.Control.Feedback>
                </Col>

                <Col lg={12} className="mb-4">
                  <Form.Label>Website *</Form.Label>
                  <Form.Control
                    type="text"
                    name="website"
                    className="mb-2"
                    placeholder="Website"
                    value={form.website}
                    onChange={handleInputChange}
                    isInvalid={!!errors.website}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.website}
                  </Form.Control.Feedback>
                </Col>
              </Row>

              <Row className="align-items-end">
                <Col lg={6} className="mb-4">
                  <Form.Label>Presale Hard Cap *</Form.Label>
                  <Form.Control
                    type="number"
                    name="hardCap"
                    placeholder="Maximum USDT you expect to earn from Presale"
                    value={form.hardCap}
                    onChange={handleInputChange}
                    isInvalid={!!errors.hardCap}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.hardCap}
                  </Form.Control.Feedback>
                </Col>
                <Col lg={6} className="mb-4">
                </Col>
                <Col lg={6} className="mb-4">
                  <Form.Label>Presale Soft Cap *</Form.Label>
                  <InputGroup className="mb-4">
                    <Form.Control aria-label="Text input with dropdown button"
                      type="number"
                      name="softCap"
                      placeholder="Minimum USDT earning required to list on CDEX"
                      value={form.softCap}
                      onChange={handleInputChange}
                      isInvalid={!!errors.softCap}
                      disabled={true}

                    />
                    <Form.Select
                      value={percent}
                      onChange={handlePercentChange}
                      variant="outline-secondary"
                      title="60%"
                      className="
                      percentageDropdown"
                      id="input-group-dropdown-2"
                      style={{ maxWidth: "90px" }}
                      align="end"
                    >
                      {percentage.map((option, index) => (
                        <option key={index} value={option}>
                          {option} %
                        </option>
                      ))}
                    </Form.Select>
                  </InputGroup>
                </Col>
                {/* <p
                style={{
                  textAlign:"left",
                  fontSize: "12px",
                  fontStyle: "italic",
                  marginTop:"-10px"
                }}
              >60% of the amount raised through presale will be locked in the CDEX USDT Liquidity Pool. Remaining 40% will be transferred back to the project owner</p> */}
              </Row>
              <Row className="mb-4">
                <Col lg={12}>
                  <Form.Label>Whitepaper *</Form.Label>
                  <Form.Control
                    type="text"
                    name="whitepaper"
                    placeholder="Add a whitepaper link here."
                    value={form.whitepaper}
                    onChange={handleInputChange}
                  />
                </Col>

                <Form.Label className="mt-4">
                  Project Social Accounts (Up to 10 accounts)
                </Form.Label>
                {form.socialAccounts.map((account, index) => (
                  <React.Fragment key={index}>
                    <Col lg={6} className="mb-4">
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Social Account name"
                        value={account.name}
                        onChange={(e) => handleSocialAccountChange(index, e)}
                      />
                    </Col>
                    <Col lg={6} className="mb-4">
                      <Form.Control
                        type="text"
                        name="link"
                        placeholder="Add a link here."
                        value={account.link}
                        onChange={(e) => handleSocialAccountChange(index, e)}
                      />
                    </Col>
                  </React.Fragment>
                ))}
                <div className="text-end">
                  <Button variant="add" onClick={addSocialAccount}>
                    + Add more
                  </Button>
                </div>
              </Row>

              <div className="mt-5">
                <h6>
                  IMPORTANT: Special Liquidity Management SpecialLM - must agree *
                </h6>
                <p>
                  (Here is the description for the project owners, what they
                  have to agree upon prior to listing their project. This will
                  be a contract between INFI CDEX and the starting project that
                  needs to be <b>AGREE</b> and <b>CONFIRM</b> by the project
                  owner)
                </p>
              </div>

              <div className="d-flex align-items-baseline">
                <Form.Check
                  className="me-2"
                  checked={form.agree}
                  onChange={handleCheckboxChange}
                  isInvalid={!!errors.agree}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.agree}
                </Form.Control.Feedback>
                <span>
                  Project owners must lock liquidity for a minimum of six
                  months, during which the liquidity remains inaccessible.
                  Safeguards are in place for companies to investigate and halt
                  trading if a scam or suspicious transaction is spotted. In
                  case of a confirmed scam, investors take precedence, impacting
                  the locked liquidity. Post the lock period, project owners
                  need approval from INFI ADMIN to access the liquidity, and
                  must justify their request
                </span>
              </div>

              <hr />
              <div className="mb-4 text-center">
                <Button variant="dark" className="px-4 py-2" onClick={e => { handleSubmit(e) }} >
                  Submit
                </Button>
                <p className="mt-2">
                  Never submit password or credit card details through workform
                </p>
              </div>
            </div>
          </Form>
        </Container>
      </section>
           {/* === MAIN PACKAGES SECTION === */}
      <section className="py-5 bg-light" id="packages">
        <Container>
          <h2 className="text-center mb-4">🚀 Paid Promotion Packages</h2>
          <p className="text-center text-muted mb-5">
            Launch your presale for <strong>FREE</strong> – and boost it with one of our premium options.
          </p>
          <Row className="g-4">
            <Col md={12} lg={12}>
              <Card className="shadow-sm border-primary h-100">
                <Card.Body>
                  <Card.Title className="text-primary">Banner Placement – Hourly Booking</Card.Title>
                  <Card.Text>
                    Get featured on the Launchpad with a prime banner slot at <strong>52 USDT/hour</strong>.
                  </Card.Text>
                  <ListGroup variant="flush" className="mb-3">
                    <ListGroup.Item><strong>Max Booking:</strong> 100 hours / project</ListGroup.Item>
                    <ListGroup.Item><strong>Ideal For:</strong> Strategic visibility during peak traffic periods</ListGroup.Item>
                  </ListGroup>
                  <Button variant="primary">Book Now</Button>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6} lg={4}>
              <Card className="shadow-sm border-success h-100">
                <Card.Body>
                  <Card.Title className="text-success">BASIC BOOST – 399 USDT</Card.Title>
                  <Card.Text>Ideal for early-stage projects seeking initial traction.</Card.Text>
                  <Card.Subtitle className="mb-2 text-muted">Includes:</Card.Subtitle>
                  <ListGroup variant="flush" className="mb-3">
                    <ListGroup.Item>✅ Featured Placement on Launchpad for 3 days</ListGroup.Item>
                    <ListGroup.Item>✅ 1 Social Media Post (X + LinkedIn)</ListGroup.Item>
                    <ListGroup.Item>✅ Mention in INFI Weekly Newsletter</ListGroup.Item>
                  </ListGroup>
                  <Button variant="success">Get Boost</Button>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6} lg={4}>
              <Card className="shadow-sm border-warning h-100">
                <Card.Body>
                  <Card.Title className="text-warning">GROWTH PACKAGE – 799 USDT</Card.Title>
                  <Card.Text>Designed to get your project noticed across multiple channels.</Card.Text>
                  <Card.Subtitle className="mb-2 text-muted">Includes:</Card.Subtitle>
                  <ListGroup variant="flush" className="mb-3">
                    <ListGroup.Item>✅ Featured Placement on Launchpad for 7 days</ListGroup.Item>
                    <ListGroup.Item>✅ 2 Social Media Posts (Twitter/X + Telegram)</ListGroup.Item>
                    <ListGroup.Item>✅ 1 AMA Slot in INFI Telegram Group or X</ListGroup.Item>
                    <ListGroup.Item>✅ Mention in 2 INFI Newsletters</ListGroup.Item>
                    <ListGroup.Item>✅ Banner Placement on Launchpad Front Page</ListGroup.Item>
                  </ListGroup>
                  <Button variant="warning" className="text-white">Choose Growth</Button>
                </Card.Body>
              </Card>
            </Col>

            <Col  md={6} lg={4}>
              <Card className="shadow-lg border-danger h-100">
                <Card.Body>
                  <Card.Title className="text-danger fw-bold">🔥 DOMINATOR PACKAGE – 1699 USDT</Card.Title>
                  <Card.Text>
                    Maximum visibility for projects looking to dominate the presale space.
                  </Card.Text>
                  <Card.Subtitle className="mb-2 text-muted">Includes:</Card.Subtitle>
                  <ListGroup variant="flush" className="mb-3">
                    <ListGroup.Item>✅ INFI Certified Project Badge</ListGroup.Item>
                    <ListGroup.Item>✅ 3 Social Media Posts + Pinned Tweet</ListGroup.Item>
                    <ListGroup.Item>✅ Full AMA in INFI & Partner Telegram Groups</ListGroup.Item>
                    <ListGroup.Item>✅ Press Release in 3 Major Crypto Media Outlets</ListGroup.Item>
                    <ListGroup.Item>✅ Dedicated Email Campaign</ListGroup.Item>
                    <ListGroup.Item>✅ 5 Minute Influencer Promo Video</ListGroup.Item>
                    <ListGroup.Item>✅ Priority Support</ListGroup.Item>
                  </ListGroup>
                  <Button variant="danger">Go Dominator</Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* === ADD-ONS SECTION === */}
      <section className="py-5 bg-white" id="addons">
        <Container>
          <h2 className="text-center mb-4">✨ Optional Add-ons</h2>
          <Row className="g-4">
            <Col md={6} lg={4}>
              <Card className="border-secondary h-100">
                <Card.Body>
                  <Card.Title>🎯 Influencer Collaboration</Card.Title>
                  <Card.Text><strong>300 USDT</strong></Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="border-secondary h-100">
                <Card.Body>
                  <Card.Title>📰 Custom Press Release Creation</Card.Title>
                  <Card.Text><strong>350 USDT</strong> – Global Distribution</Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="border-secondary h-100">
                <Card.Body>
                  <Card.Title>🎬 Promotional Video Creation</Card.Title>
                  <Card.Text><strong>500 USDT</strong> – Professional video for your project</Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={12}>
              <Card className="border-secondary">
                <Card.Body>
                  <Card.Title>📊 Tokenomics & Pitch Deck Review</Card.Title>
                  <Card.Text>
                    <strong>250 USDT</strong><br />
                    Includes a detailed professional review of your project's fundamentals, token structure, and pitch materials – identifying potential weaknesses and areas for improvement from the perspective of an experienced crypto analyst.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <hr className="my-5" />

          <Alert variant="info" className="text-center">
            🧩 <strong>Every package includes a FREE strategy consultation</strong> with our INFI Marketing Team.
          </Alert>

          <Alert variant="warning" className="text-center">
            🛠 <strong>Custom promotion packages</strong> available upon request.
          </Alert>

          <div className="text-center mt-4">
            <h4 className="fw-bold">Amplify Your Crypto Project</h4>
            <p className="text-muted">
              Launch your presale for <strong>FREE</strong> on our Launchpad – and if you're ready to go bigger, choose from our Paid Promotion Packages to dramatically increase your reach and visibility.
            </p>
            <p className="mt-3">
              📩 <strong>Interested?</strong> Contact us at <a href="mailto:laszlo.kellner@infimultichain.com">laszlo.kellner@infimultichain.com</a>
            </p>
          </div>
        </Container>
      </section>
      <Footer />
    </>
  );
}